import React, { Component } from 'react';
import '../../ai-assistant.css';

class AiAssistantTray extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            messages: [{
                role: 'bot',
                text: 'Hola, soy tu asistente inteligente. ¿Buscas algún servicio o negocio registrado hoy?',
                sources: []
            }],
            userInput: '',
            isLoading: false
        };
        this.chatBodyRef = React.createRef();
    }

    toggleOpen = () => {
        this.setState(prevState => ({
            isOpen: !prevState.isOpen
        }));
    }

    handleInputChange = (e) => {
        this.setState({ userInput: e.target.value });
    }

    handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.handleSend();
        }
    }

    handleSend = () => {
        const { userInput } = this.state;
        if (!userInput.trim()) return;

        // Add User Message
        this.addMessage('user', userInput);
        this.setState({ userInput: '', isLoading: true });

        // Determine API URL based on environment
        // In production (live), the backend is at root. In dev, it's under /dev
        const apiUrl = process.env.REACT_APP_ENV === 'live' 
            ? '/v1/ai/chat' 
            : '/dev/v1/ai/chat';

        // Call Backend
        fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ message: userInput })
        })
            .then(res => res.json())
            .then(data => {
                // Add Bot Message
                this.addMessage('bot', data.response, data.sources);
            })
            .catch(err => {
                console.error(err);
                this.addMessage('bot', 'Lo siento, tuve un problema conectando con el servidor.');
            })
            .finally(() => {
                this.setState({ isLoading: false });
            });
    }

    addMessage = (role, text, sources = []) => {
        this.setState(prevState => ({
            messages: [...prevState.messages, { role, text, sources }]
        }), () => {
            // Scroll to bottom
            if (this.chatBodyRef.current) {
                this.chatBodyRef.current.scrollTop = this.chatBodyRef.current.scrollHeight;
            }
        });
    }

    render() {
        const { isOpen, messages, userInput, isLoading } = this.state;
        const containerClass = isOpen ? 'ai-assistant-tray-container expanded' : 'ai-assistant-tray-container';

        return (
            <div className={containerClass}>
                {/* Expanded Panel */}
                <div className="ai-assistant-panel">
                    <div className="ai-chat-header">
                        <span style={{ fontWeight: 'bold', color: '#333' }}>Asistente La Guía Mundial</span>
                        <button onClick={(e) => { e.stopPropagation(); this.toggleOpen(); }} style={{ border: 'none', background: 'transparent', cursor: 'pointer', fontSize: '20px' }}>
                            &times;
                        </button>
                    </div>
                    <div className="ai-chat-body" ref={this.chatBodyRef}>
                        {messages.map((msg, idx) => (
                            <div key={idx} className={`ai-message ${msg.role}`}>
                                <div style={{ whiteSpace: 'pre-wrap' }}>{msg.text}</div>
                                {msg.sources && msg.sources.length > 0 && (
                                    <ul style={{ marginTop: '10px', paddingLeft: '0', listStyleType: 'none' }}>
                                        {msg.sources.map((src, i) => (
                                            <li key={i} style={{ marginBottom: '12px', lineHeight: '1.5' }}>
                                                <span style={{ fontWeight: 'bold', color: '#555' }}>
                                                    {src.category}:
                                                </span>{' '}
                                                <a
                                                    href={`/enterprise-detail?id=${src.id}`}
                                                    style={{ textDecoration: 'underline', color: '#007bff', fontWeight: 'bold', cursor: 'pointer' }}
                                                >
                                                    {src.name}
                                                </a>{' '}
                                                <span style={{ color: '#777' }}>
                                                    ({src.address})
                                                </span>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        ))}
                        {isLoading && <div className="ai-message bot">...</div>}
                    </div>
                    <div className="ai-chat-input-area">
                        <input
                            type="text"
                            placeholder="Escribe tu consulta..."
                            value={userInput}
                            onChange={this.handleInputChange}
                            onKeyPress={this.handleKeyPress}
                            autoFocus
                        />
                        <button onClick={this.handleSend}>Enviar</button>
                    </div>
                </div>

                <div className="ai-assistant-tray" onClick={this.toggleOpen}>
                    <div className="ai-orb"></div>
                    <div className="ai-tray-input-mock">
                        {isOpen ? 'Asistente Activo' : 'Pregúntame sobre estas ofertas...'}
                    </div>
                </div>
            </div>
        );
    }
}

export default AiAssistantTray;
